import { Button, Heading, Stack, Text } from '@lmc/design-system'
import { cssVars } from '@lmc/design-system/tokens'
import { ssoLogout } from 'common/services/sso'
import { NAMESPACE } from 'locale'
import { careOfficeAccessConstants as keys } from 'locale/careOfficeAccess'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const { color, font, fontWeight, spacing, text } = cssVars

const Wrapper = styled.main`
  max-width: 528px;
  margin: 0 auto;
  padding: 30vh ${spacing['200']} ${spacing['600']};

  img {
    width: 240px;
    max-width: 60vw;
  }

  /*
   * The app's legacy element styles (h1, p, button) are unlayered, so they beat the
   * design system's layered utilities. Re-apply the design-system tokens here until
   * the legacy CSS moves into a cascade layer.
   */
  h1 {
    margin: 0;
    font-size: ${text.heading.lg.size};
    line-height: ${text.heading.lg.lineHeight};
    font-weight: ${fontWeight.semibold};
    color: ${color.text.primary};
  }

  p {
    color: ${color.text.primary};
  }

  button {
    font-family: ${font.body};
    font-size: ${text.body.md.size};
    line-height: ${text.body.md.lineHeight};
    font-weight: ${fontWeight.medium};
    color: ${color.text.action.inverse.default};
  }
`

const NoCareOfficeAccess = () => {
  const { t } = useTranslation(NAMESPACE.CARE_OFFICE_ACCESS)

  return (
    <Wrapper>
      <Stack gap="400" align="center">
        <img src="/images/lmc_logo_large.png" alt={t(keys.LOGO_ALT)} />
        <Stack gap="200" align="center">
          <Heading as="h1" size="lg" align="center">
            {t(keys.NO_ACCESS_TITLE)}
          </Heading>
          <Stack gap="50" align="center">
            <Text align="center">{t(keys.NO_ACCESS_BODY)}</Text>
            <Text align="center">{t(keys.NO_ACCESS_HINT)}</Text>
          </Stack>
          <Button onClick={() => ssoLogout()}>
            {t(keys.NO_ACCESS_SIGN_OUT)}
          </Button>
        </Stack>
      </Stack>
    </Wrapper>
  )
}

export default NoCareOfficeAccess
